// As stored by the platform; iOS cannot detect ALLOWED_ONCE, so nothing reports it today.
enum LocationPermission {
  ALLOWED_ONCE = "allowed-once",
  ALWAYS = "always",
  OFF = "off",
  WHILE_USING = "while-using",
}

export default LocationPermission;
